exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Compatible with Leaflet 0.7 */\n.leaflet-control-locate a {\n  font-size: 1.4em;\n  color: #444;\n  cursor: pointer; }\n\n.leaflet-control-locate.active a {\n  color: #2074B6; }\n\n.leaflet-control-locate.active.following a {\n  color: #FC8428; }\n", ""]);

// exports
